var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"photo-and-text"},[_c('div',{staticClass:"row d-flex justify-content-center align-items-center"},_vm._l((_vm.photos),function(item){return _c('div',{key:item.img,staticClass:"mb-5 col-lg-4 col-12"},[_c('img',{attrs:{"src":item.img,"alt":item.alt}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }